module.exports = __webpack_public_path__ + "img/3.4e78e0b6.jpg";